import React, { useState } from "react";
import { profiles } from "../misc/Static";
import ChampionName from "../misc/ChampionName";
import Champ from "../images/Champ";
import LaneIcon from "../misc/LaneIcon";
import styles from "./RecentStats.module.css";

export const RecentStats = ({ stats }) => {
  const data = stats;
  const [currentQueue, setCurrentQueue] = useState(false);
  const [lane, setLane] = useState("all");
  const clickQueue = (e) => {
    setCurrentQueue(parseInt(e.target.getAttribute("data-id")));
    setLane("all");
  };

  const clickLane = (e) => {
    const selectLane = e.target.getAttribute("data-id");
    setLane(selectLane === lane ? "all" : selectLane);
  };

  let laneButtons = false;
  let champs = false;
  const queueButtons =
    data && data[90]
      ? profiles.statsQueues
          .filter((q, i) => data[90][q])
          .map((q, j) => {
            return {
              queue: q,
              pick: data[90][q].lanes.all.n,
              wr:
                Math.round(
                  (data[90][q].lanes.all.w / data[90][q].lanes.all.n) * 1000
                ) / 10,
            };
          })
      : [];

  if (!queueButtons.length) return <></>;
  const queue = currentQueue ? currentQueue : queueButtons[0].queue;
  if (profiles.laneQueues.indexOf(queue) !== -1) {
    laneButtons = profiles.laneNames.map((l, i) => {
      return {
        lane: l,
        pick: data[90][queue].lanes[l].n,
        wr: data[90][queue].lanes[l].n
          ? Math.round(
              (data[90][queue].lanes[l].w / data[90][queue].lanes[l].n) * 1000
            ) / 10
          : 0,
      };
    });
  }

  if (data[90][queue].champions[lane]) {
    champs = Object.keys(data[90][queue].champions[lane]).map((id, i) => {
      return {
        id: id,
        pick: data[90][queue].champions[lane][id].n,
        wr: data[90][queue].champions[lane][id].n
          ? Math.round(
              (data[90][queue].champions[lane][id].w /
                data[90][queue].champions[lane][id].n) *
                100
            )
          : 0,
        k:
          Math.round(
            (data[90][queue].champions[lane][id].k /
              data[90][queue].champions[lane][id].n) *
              10
          ) / 10,
        d:
          Math.round(
            (data[90][queue].champions[lane][id].d /
              data[90][queue].champions[lane][id].n) *
              10
          ) / 10,
        a:
          Math.round(
            (data[90][queue].champions[lane][id].a /
              data[90][queue].champions[lane][id].n) *
              10
          ) / 10,
        kda: data[90][queue].champions[lane][id].d
          ? (data[90][queue].champions[lane][id].k +
              data[90][queue].champions[lane][id].a) /
            data[90][queue].champions[lane][id].d
          : data[90][queue].champions[lane][id].k +
            data[90][queue].champions[lane][id].a,
        cs: Math.round(
          data[90][queue].champions[lane][id].cs /
            data[90][queue].champions[lane][id].n
        ),
        csMin:
          Math.round(
            (data[90][queue].champions[lane][id].cs /
              data[90][queue].champions[lane][id].t) *
              600
          ) / 10,
      };
    });
    champs.sort((a, b) => {
      a = a.pick;
      b = b.pick;
      return a > b ? -1 : a < b ? 1 : 0;
    });
  }

  return (
    <div className={styles.recentstats}>
      <h3>Last 90 Days Performance</h3>
      <div>
        {queueButtons.map((button) => (
          <div
            key={button.queue}
            className={
              styles["queue" + (queue === button.queue ? "active" : "")]
            }
            onClick={(e) => clickQueue(e)}
            data-id={button.queue}
          >
            <div>{button.pick} x</div>
            <div>{profiles.queues[button.queue]}</div>
            <div className={styles[button.wr >= 50 ? "green" : "red"]}>
              {button.wr.toFixed(1)}%
            </div>
          </div>
        ))}
      </div>
      <div>
        {laneButtons &&
          laneButtons.map((button, i) => (
            <div
              key={i}
              className={
                styles[`lanestats${lane === button.lane ? "active" : ""}`]
              }
              onClick={(e) => clickLane(e)}
              data-id={button.lane}
            >
              <div>{button.pick} x</div>
              <div>
                <LaneIcon lane={button.lane.toLowerCase()} />
              </div>
              <div className={styles[button.wr >= 50 ? "green" : "red"]}>
                {button.wr.toFixed(1)}%
              </div>
            </div>
          ))}
      </div>
      <div>
        <div className={styles.headings}>
          <div></div>
          <div>Champion</div>
          <div>Pick</div>
          <div>KDA</div>
          <div>Win</div>
        </div>
        {champs &&
          champs.map((champ, i) => (
            <div className={styles.row} key={i}>
              <div>
                <Champ
                  type="champ24b"
                  id={parseInt(champ.id)}
                  tipType="champion"
                />
              </div>
              <div>
                <div>
                  <ChampionName cid={champ.id} />
                </div>
                <div>
                  {champ.cs}CS ({champ.csMin.toFixed(1)})
                </div>
              </div>
              <div>{champ.pick}</div>
              <div className={styles.kda}>
                <div>{champ.kda.toFixed(2)} KDA</div>
                <div>
                  <span className={styles.kills}>{champ.k}</span>/
                  <span className={styles.deaths}>{champ.d}</span>/{champ.a}
                </div>
              </div>
              <div className={styles[champ.wr >= 50 ? "green" : "red"]}>
                {champ.wr}%
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default RecentStats;
